module.exports = __webpack_public_path__ + "static/media/readme.484f472a.md";